import type { VideoBriefSlide } from '@/types/videoBrief'

/** `m:ss` for a slide offset; the panel lists offsets, not durations. */
export function formatClock(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds))
  const minutes = Math.floor(whole / 60)
  const rest = whole - minutes * 60
  return `${minutes}:${rest < 10 ? '0' : ''}${rest}`
}

/**
 * The slide playing at `time`: the last one whose start is at or before it.
 * -1 before the first slide, which only happens for a storyboard that does not
 * start at zero.
 */
export function activeSlideIndex(slides: VideoBriefSlide[], time: number): number {
  let active = -1
  for (let i = 0; i < slides.length; i += 1) {
    if (slides[i].start_seconds <= time) active = i
    else break
  }
  return active
}
